import React, { useEffect, useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import "./login.scss"
import { login } from "../../redux/actions/auth.actions";
import { TextField } from "@mui/material"; // Import TextField from Material-UI
import ContactMailIcon from '@mui/icons-material/ContactMail';
import { color, motion } from "framer-motion";

const schema = yup.object().shape({
    email: yup.string().email().required("email is required"),
    password: yup
        .string()
        .matches(
            /^(?=.*[!@#$%^&()\-_=+{};:,<.>])(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{12,}$/,
            "Password must be at least 12 characters with one uppercase, one lowercase, one digit, and one special character."
        )
        .required("Password is required"),
});
const defaultValues = {
    email: "",
    password: "",
};

const buttonVariants = {
    initial: { opacity: 0, scale: 0.8 },
    animate: { opacity: 1, scale: 1, transition: { duration: 0.6, ease: "easeOut" } },
    hover: { scale: 1.05, boxShadow: "0 0 8px rgba(54, 105, 37, 0.8)" },
};


const Login = () => {
    const dispatch = useDispatch();
    const [width, setWidth] = useState(window.innerWidth)
    const navigate = useNavigate()
    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => { setShowPassword((show) => !show) };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: "onChange",
        defaultValues,
        resolver: yupResolver(schema),
    });


    const onSubmit = (data) => {
        dispatch(login(data.email, data.password)).then((res) => {
            if (res.success === true) navigate('/')
        })
    }
    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);



    return (
        <div className=' bg-image-overlay '>
            <div className="container content ">
                <div className={width >= 768 ? 'shadow-lg bg-white rounded-2 text-center  mx-auto ' : 'shadow-lg bg-white rounded-2 w-100 text-center mx-auto '} >
                    <div className={`login-box ${width >= 768 ? 'desktop' : 'mobile'}`}>
                        <div className="form-container">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <motion.h6
                                    className="contact-us-text text-uppercase underline-red fs-5 fw-bold text-center mb-4"
                                    animate={{ rotate: [0, 15, -15, 0] }}
                                    transition={{ duration: 1, repeat: Infinity }}
                                >
                                    <VpnKeyIcon sx={{ color: "rgba(0, 165, 162, 0.7)" }} fontSize="large" />
                                </motion.h6>
                                <motion.h3
                                    className="h2-tag text-uppercase mb-3  mb-4"
                                    initial={{ x: -100, opacity: 0 }}
                                    animate={{ x: 0, opacity: 1 }}
                                    transition={{ duration: 0.6, ease: "easeOut" }}
                                >
                                    Welcome Back! On CBMS
                                </motion.h3>
                                {/* Email */}
                                <Controller
                                    name="email"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            id="email"
                                            label="Email"
                                            variant="outlined"
                                            error={!!errors.email}
                                            className="w-100"
                                            helperText={errors.email ? errors.email.message : ""}
                                            InputProps={{
                                                endAdornment: (
                                                    <IconButton aria-label="toggle email visibility" edge="end">
                                                        <motion.div animate={{ rotate: [0, 15, -15, 0] }}
                                                            transition={{ duration: 1, repeat: Infinity }}>
                                                            <ContactMailIcon className={errors.email ? "text-danger" : "avatar_icons"} />
                                                        </motion.div>
                                                    </IconButton>
                                                ),
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'rgba(0, 165, 162, 0.7)',   // default border color
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'rgba(0, 165, 162, 0.9)',   // on hover
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'rgba(0, 165, 162, 1)',     // when focused
                                                    },
                                                    '&.Mui-error fieldset': {
                                                        borderColor: 'red',                       // when error
                                                    },

                                                },
                                            }}
                                        />
                                    )}
                                />

                                {/* Password */}
                                    <Controller
                                        name="password"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                type={showPassword ? "text" : "password"}
                                                id="password"
                                                label="Password"
                                                variant="outlined"
                                                error={!!errors.password}
                                                className="w-100"
                                                
                                                helperText={errors.password ? errors.password.message : ""}
                                                InputProps={{
                                                    endAdornment: (
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowPassword}
                                                            onMouseDown={handleMouseDownPassword}
                                                            edge="end"
                                                        >
                                                            {showPassword ? (
                                                                <motion.div animate={{ rotate: [0, 15, -15, 0] }}
                                                                    transition={{ duration: 1, repeat: Infinity }}>
                                                                    <Visibility className={errors.password ? "text-danger" : "avatar_icons"} />
                                                                </motion.div>
                                                            ) : (
                                                                <motion.div animate={{ rotate: [0, 15, -15, 0] }}
                                                                    transition={{ duration: 1, repeat: Infinity }}>
                                                                    <VisibilityOff className={errors.password ? "text-danger" : "avatar_icons"} />
                                                                </motion.div>
                                                            )}
                                                        </IconButton>
                                                    ),
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        '& fieldset': {
                                                            borderColor: 'rgba(0, 165, 162, 0.7)',   // default border color
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: 'rgba(0, 165, 162, 0.9)',   // on hover
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            borderColor: 'rgba(0, 165, 162, 1)',     // when focused
                                                        },
                                                        '&.Mui-error fieldset': {
                                                            borderColor: 'red',                       // when error
                                                        },

                                                    },
                                                }}
                                            />
                                        )}
                                    />

                                {/* Button */}
                                <motion.button
                                    className="sub-button btn w-75"
                                    type="submit"
                                    variants={buttonVariants}
                                    initial="initial"
                                    animate="animate"
                                    whileHover="hover"
                                >
                                    Login
                                </motion.button>

                                <p className="mt-3 fs-6 fw-bold" style={{ fontFamily: "Comfortaa" }}>
                                    <motion.span
                                        className="text-danger d-inline-block ms-2"
                                        animate={{ x: [0, 5, -5, 0] }}
                                        transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
                                    >
                                        Forgot password?
                                    </motion.span>
                                    {" "}
                                    Please contact your admin.
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
